export const LOAD_PEOPLE_LISTS_REQUEST = 'LOAD_PEOPLE_LISTS_REQUEST'
export const LOAD_PEOPLE_LISTS_SUCCESS = 'LOAD_PEOPLE_LISTS_SUCCESS'
export const LOAD_PEOPLE_LISTS_ERROR = 'LOAD_PEOPLE_LISTS_ERROR'

export const LOAD_PEOPLE_LIST_REQUEST = 'LOAD_PEOPLE_LIST_REQUEST'
export const LOAD_PEOPLE_LIST_SUCCESS = 'LOAD_PEOPLE_LIST_SUCCESS'
export const LOAD_PEOPLE_LIST_ERROR = 'LOAD_PEOPLE_LIST_ERROR'

export const CREATE_PEOPLE_LIST_REQUEST = 'CREATE_PEOPLE_LIST_REQUEST'
export const CREATE_PEOPLE_LIST_SUCCESS = 'CREATE_PEOPLE_LIST_SUCCESS'
export const CREATE_PEOPLE_LIST_ERROR = 'CREATE_PEOPLE_LIST_ERROR'

export const UPDATE_PEOPLE_LIST_REQUEST = 'UPDATE_PEOPLE_LIST_REQUEST'
export const UPDATE_PEOPLE_LIST_SUCCESS = 'UPDATE_PEOPLE_LIST_SUCCESS'
export const UPDATE_PEOPLE_LIST_ERROR = 'UPDATE_PEOPLE_LIST_ERROR'

export const DELETE_PEOPLE_LIST_REQUEST = 'DELETE_PEOPLE_LIST_REQUEST'
export const DELETE_PEOPLE_LIST_SUCCESS = 'DELETE_PEOPLE_LIST_SUCCESS'
export const DELETE_PEOPLE_LIST_ERROR = 'DELETE_PEOPLE_LIST_ERROR'

export const ADD_CONTACT_TO_PEOPLE_LIST_REQUEST = 'ADD_CONTACT_TO_PEOPLE_LIST_REQUEST'
export const ADD_CONTACT_TO_PEOPLE_LIST_SUCCESS = 'ADD_CONTACT_TO_PEOPLE_LIST_SUCCESS'
export const ADD_CONTACT_TO_PEOPLE_LIST_ERROR = 'ADD_CONTACT_TO_PEOPLE_LIST_ERROR'

export const REMOVE_CONTACT_FROM_PEOPLE_LIST_REQUEST = 'REMOVE_CONTACT_FROM_PEOPLE_LIST_REQUEST'
export const REMOVE_CONTACT_FROM_PEOPLE_LIST_SUCCESS = 'REMOVE_CONTACT_FROM_PEOPLE_LIST_SUCCESS'
export const REMOVE_CONTACT_FROM_PEOPLE_LIST_ERROR = 'REMOVE_CONTACT_FROM_PEOPLE_LIST_ERROR'

export const ADD_USER_TO_PEOPLE_LIST_REQUEST = 'ADD_USER_TO_PEOPLE_LIST_REQUEST'
export const ADD_USER_TO_PEOPLE_LIST_SUCCESS = 'ADD_USER_TO_PEOPLE_LIST_SUCCESS'
export const ADD_USER_TO_PEOPLE_LIST_ERROR = 'ADD_USER_TO_PEOPLE_LIST_ERROR'

export const REMOVE_USER_FROM_PEOPLE_LIST_REQUEST = 'REMOVE_USER_FROM_PEOPLE_LIST_REQUEST'
export const REMOVE_USER_FROM_PEOPLE_LIST_SUCCESS = 'REMOVE_USER_FROM_PEOPLE_LIST_SUCCESS'
export const REMOVE_USER_FROM_PEOPLE_LIST_ERROR = 'REMOVE_USER_FROM_PEOPLE_LIST_ERROR'

export const ADD_PEOPLE_LIST_TO_OPENED_LISTS = 'ADD_PEOPLE_LIST_TO_OPENED_LISTS'
export const REMOVE_PEOPLE_LIST_FROM_OPENED_LISTS = 'REMOVE_PEOPLE_LIST_FROM_OPENED_LISTS'
export const SET_ACTIVE_PEOPLE_LIST = 'SET_ACTIVE_PEOPLE_LIST'
export const TOGGLE_SELECT_ALL_PEOPLE_CONTACT = 'TOGGLE_SELECT_ALL_PEOPLE_CONTACT'

// ---------------------
// ORG LISTS START
// --------------------
export const LOAD_ORGANIZATION_LISTS_REQUEST = 'LOAD_ORGANIZATION_LISTS_REQUEST'
export const LOAD_ORGANIZATION_LISTS_SUCCESS = 'LOAD_ORGANIZATION_LISTS_SUCCESS'
export const LOAD_ORGANIZATION_LISTS_ERROR = 'LOAD_ORGANIZATION_LISTS_ERROR'

export const LOAD_ORGANIZATION_LIST_REQUEST = 'LOAD_ORGANIZATION_LIST_REQUEST'
export const LOAD_ORGANIZATION_LIST_SUCCESS = 'LOAD_ORGANIZATION_LIST_SUCCESS'
export const LOAD_ORGANIZATION_LIST_ERROR = 'LOAD_ORGANIZATION_LIST_ERROR'

export const CREATE_ORGANIZATION_LIST_REQUEST = 'CREATE_ORGANIZATION_LIST_REQUEST'
export const CREATE_ORGANIZATION_LIST_SUCCESS = 'CREATE_ORGANIZATION_LIST_SUCCESS'
export const CREATE_ORGANIZATION_LIST_ERROR = 'CREATE_ORGANIZATION_LIST_ERROR'

export const UPDATE_ORGANIZATION_LIST_REQUEST = 'UPDATE_ORGANIZATION_LIST_REQUEST'
export const UPDATE_ORGANIZATION_LIST_SUCCESS = 'UPDATE_ORGANIZATION_LIST_SUCCESS'
export const UPDATE_ORGANIZATION_LIST_ERROR = 'UPDATE_ORGANIZATION_LIST_ERROR'

export const DELETE_ORGANIZATION_LIST_REQUEST = 'DELETE_ORGANIZATION_LIST_REQUEST'
export const DELETE_ORGANIZATION_LIST_SUCCESS = 'DELETE_ORGANIZATION_LIST_SUCCESS'
export const DELETE_ORGANIZATION_LIST_ERROR = 'DELETE_ORGANIZATION_LIST_ERROR'

export const ADD_CONTACT_TO_ORGANIZATION_LIST_REQUEST = 'ADD_CONTACT_TO_ORGANIZATION_LIST_REQUEST'
export const ADD_CONTACT_TO_ORGANIZATION_LIST_SUCCESS = 'ADD_CONTACT_TO_ORGANIZATION_LIST_SUCCESS'
export const ADD_CONTACT_TO_ORGANIZATION_LIST_ERROR = 'ADD_CONTACT_TO_ORGANIZATION_LIST_ERROR'

export const REMOVE_CONTACT_FROM_ORGANIZATION_LIST_REQUEST = 'REMOVE_CONTACT_FROM_ORGANIZATION_LIST_REQUEST'
export const REMOVE_CONTACT_FROM_ORGANIZATION_LIST_SUCCESS = 'REMOVE_CONTACT_FROM_ORGANIZATION_LIST_SUCCESS'
export const REMOVE_CONTACT_FROM_ORGANIZATION_LIST_ERROR = 'REMOVE_CONTACT_FROM_ORGANIZATION_LIST_ERROR'


export const ADD_USER_TO_ORGANIZATION_LIST_REQUEST = 'ADD_USER_TO_ORGANIZATION_LIST_REQUEST'
export const ADD_USER_TO_ORGANIZATION_LIST_SUCCESS = 'ADD_USER_TO_ORGANIZATION_LIST_SUCCESS'
export const ADD_USER_TO_ORGANIZATION_LIST_ERROR = 'ADD_USER_TO_ORGANIZATION_LIST_ERROR'

export const REMOVE_USER_FROM_ORGANIZATION_LIST_REQUEST = 'REMOVE_USER_FROM_ORGANIZATION_LIST_REQUEST'
export const REMOVE_USER_FROM_ORGANIZATION_LIST_SUCCESS = 'REMOVE_USER_FROM_ORGANIZATION_LIST_SUCCESS'
export const REMOVE_USER_FROM_ORGANIZATION_LIST_ERROR = 'REMOVE_USER_FROM_ORGANIZATION_LIST_ERROR'

export const ADD_ORGANIZATIONS_LIST_TO_OPENED_LISTS = 'ADD_ORGANIZATIONS_LIST_TO_OPENED_LISTS'
export const REMOVE_ORGANIZATIONS_LIST_FROM_OPENED_LISTS = 'REMOVE_ORGANIZATIONS_LIST_FROM_OPENED_LISTS'
export const SET_ACTIVE_ORGANIZATIONS_LIST = 'SET_ACTIVE_ORGANIZATIONS_LIST'
export const TOGGLE_SELECT_ALL_ORGANIZATION_CONTACT = 'TOGGLE_SELECT_ALL_ORGANIZATION_CONTACT'
